export const level_4 = '0 2px 4px 0 rgba(0,0,0,0.10)'
export const level_8 = '0 4px 8px 0 rgba(0,0,0,0.10)'
export const level_16 = '0 8px 16px 0 rgba(0,0,0,0.10)'
export const level_24 = '0 16px 24px 0 rgba(0,0,0,0.10)'
